import { render, staticRenderFns } from "./MarchResult.vue?vue&type=template&id=3982cd50&scoped=true&"
import script from "./MarchResult.vue?vue&type=script&lang=js&"
export * from "./MarchResult.vue?vue&type=script&lang=js&"
import style0 from "./MarchResult.vue?vue&type=style&index=0&id=3982cd50&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3982cd50",
  null
  
)

export default component.exports